'use strict';

const isKeyCodeNumber = (code) => {
    return !(code > 31 && (code < 48 || code > 57));
};

module.exports = isKeyCodeNumber;
